import React, { useState, useEffect } from "react";
import {
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import addReservation from "../../../api/store/addReservation";
import zhTW from "date-fns/locale/zh-TW";
import { zhHK } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";

const AddReservationDialog = ({
  storeCode,
  tableCode,
  onAddReservation,
  open,
  onClose,
}) => {
  const [reservationTime, setReservationTime] = useState({
    StartDate: new Date(),
    EndDate: new Date(),
  });
  const [message, setMessage] = useState("");

  const handleAddReservation = async () => {
    try {
      const response = await addReservation(
        reservationTime.StartDate,
        reservationTime.EndDate,
        tableCode,
        storeCode
      );
      if ((response.Code = "000")) {
        const newReservation = {
          StartTime: reservationTime.StartDate,
          EndTime: reservationTime.EndDate,
          expiration_time: new Date("2300-01-01"),
        };
        onAddReservation(newReservation, tableCode);
      }

      onClose();
    } catch (error) {
      setMessage(`Error: ${error.message || "Failed to add reservation."}`);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>新增訂位</DialogTitle>
      <DialogContent>
        <Stack direction={"row"} spacing={2} sx={{ marginTop: 2 }}>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            localeText={
              zhHK.components.MuiLocalizationProvider.defaultProps.localeText
            }
            adapterLocale={zhTW}
          >
            <DateTimePicker
              label="開始日期"
              value={new Date(reservationTime.StartDate)}
              onChange={(newValue) =>
                setReservationTime((prev) => ({ ...prev, StartDate: newValue }))
              }
              renderInput={(params) => <TextField {...params} />}
              ampm={false}
              format="yyyy/MM/dd HH:mm"
            />
            <DateTimePicker
              label="結束日期"
              value={new Date(reservationTime.EndDate)}
              onChange={(newValue) =>
                setReservationTime((prev) => ({ ...prev, EndDate: newValue }))
              }
              renderInput={(params) => <TextField {...params} />}
              ampm={false}
              format="yyyy/MM/dd HH:mm"
            />
          </LocalizationProvider>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          取消
        </Button>
        <Button
          onClick={handleAddReservation}
          color="secondary"
          disabled={reservationTime.EndDate <= reservationTime.StartDate}
        >
          確認
        </Button>
      </DialogActions>
      {message && <p>{message}</p>}
    </Dialog>
  );
};

export default AddReservationDialog;
